import { useTokenPermissions } from "./useTokenPermissions";
import { TokenPermissionModule } from "../constants/permissions";

export function useCurationTokenPermissions() {
  const { canView, canEdit, canAccess } = useTokenPermissions();

  const canViewCuration = (): boolean => {
    return canView(TokenPermissionModule.EDITORIAL_CONTENT);
  };

  const canViewCurationDashboard = (): boolean => {
    return canView(TokenPermissionModule.EDITORIAL_DASHBOARD);
  };

  const canEditCuration = (): boolean => {
    return canEdit(TokenPermissionModule.EDITORIAL_CONTENT);
  };

  const canAccessCuration = (): boolean => {
    return canAccess(TokenPermissionModule.EDITORIAL_CONTENT);
  };

  return {
    canViewCuration,
    canViewCurationDashboard,
    canEditCuration,
    canAccessCuration,
  };
}
